import { Button } from "@/shared/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/shared/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import type { DisplayAttribute } from "@/features/admin/panels/categories/hooks/useCategoryAttributesDisplay";

interface AttributeFieldProps {
  attribute: DisplayAttribute;
  value: string | number | undefined;
  isRequired: boolean;
  onChange: (value: string | number | undefined) => void;
}

export function AttributeField({
  attribute,
  value,
  isRequired,
  onChange,
}: AttributeFieldProps) {
  const options = [...attribute.values]
    .sort((a, b) => a.order - b.order)
    .map((v) => v.value);

  return (
    <div>
      <label className="block text-sm font-medium text-ink-900 mb-1.5 truncate">
        {attribute.name}
        {isRequired && <span className="text-red-500 ml-1">*</span>}
      </label>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-full justify-between">
            <span className="text-sm truncate text-left min-w-0 flex-1">
              {value ? String(value) : `Select ${attribute.name}`}
            </span>
            <ChevronDown className="h-4 w-4 shrink-0 ml-2" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 max-h-[300px] overflow-y-auto">
          <DropdownMenuLabel>{attribute.name}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {!isRequired && (
            <DropdownMenuItem onClick={() => onChange(undefined)}>
              Clear selection
            </DropdownMenuItem>
          )}
          {options.length === 0 ? (
            <DropdownMenuItem disabled>No options available</DropdownMenuItem>
          ) : (
            options.map((option) => (
              <DropdownMenuItem key={option} onClick={() => onChange(option)}>
                <span className="truncate">{option}</span>
              </DropdownMenuItem>
            ))
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
